/*jshint esversion: 6 */
/* global interact */
import { Controller } from "stimulus";
import Sortable from 'sortablejs';
import { htmlToElement } from '.././helpers/dom';

export default class extends Controller {
  static targets = [ "transcriptCourseTemplate", "transcriptCoursesFormContainer", "transcriptCourseName", "transcriptCourseForm" ]

  connect() {
    // if (this.hasSchoolSubjectAreaFormTarget) {
    //   // Show the first skill category while all others are hiding
    //   this.transcriptCourseFormTargets[0].classList.toggle('hidden');
    // }

    // Make the skill category selectors sortable
    const sortable = document.querySelector('#transcript-courses-sortable.sortable');
    var el = Sortable.create(sortable, {
      animation: 150,
      draggable: "li.btn",
      filter: ".ignore-sort",
      forceFallback: true,
      onEnd: function(event) {
        let transcriptCourseId = event.item.getAttribute('data-transcript-course-id');
        document.querySelector(`[data-transcript-course-id="${transcriptCourseId}"] input.position`).value = event.newIndex + 1;
      }
    });

    // Highlight initial skill category
    // document.querySelector('#transcript-courses-sortable.sortable li').classList.add('btn-pink');
  }

  switchTo(event) {
    this.transcriptCourseFormTargets.forEach((el, i) => {
      el.classList.toggle("hidden", el.dataset.transcriptCourseId != event.target.dataset.transcriptCourseId)
    });

    // Highlight selected tab
    let sortableSelector = '#transcript-courses-sortable.sortable li.btn-pink'
    if (document.querySelector(sortableSelector) != null) {
      document.querySelector(sortableSelector).classList.remove('btn-pink');
    }
    event.target.classList.add('btn-pink');
  }

  addNewItem(event) {
    const id = new Date().getTime();
    const template = `<li class='inline-block mr-10 mb-14 btn' data-target='schools--transcript-courses.transcriptCourseName' data-action='click->schools--transcript-courses#switchTo' data-transcript-course-id='${id}'>New Course</li>`
    const newElementLink = htmlToElement(template);
    const parentElement = document.getElementById("transcript-courses-sortable");
    parentElement.insertAdjacentElement("beforeend", newElementLink);
    newElementLink.addEventListener("click", (ev) => {
      this.switchTo(ev);
    });
    const newElementForm = htmlToElement(this.transcriptCourseTemplateTarget.innerHTML.replace(/TEMPLATE_RECORD/g, id));
    newElementForm.dataset.transcriptCourseId = id;
    this.transcriptCoursesFormContainerTarget.insertAdjacentElement('beforeend', newElementForm);

    window.expandableTextArea();
    newElementLink.click();
  }

  updateTitle(event) {
    const transcriptCourseId = event.target.parentElement.parentElement.parentElement.dataset.transcriptCourseId;
    this.transcriptCourseNameTargets.find(el => el.dataset.transcriptCourseId  == transcriptCourseId).innerText = event.target.value;
  }

  removeItem(event) {
    if (confirm('Are you sure?') == true) {
      const itemForm = event.target.parentElement;
      const transcriptCourseId = itemForm.dataset.transcriptCourseId;
      this.transcriptCourseNameTargets.find(el => el.dataset.transcriptCourseId  == transcriptCourseId).style.display = 'none';
      itemForm.querySelector("input[name*='_destroy']").value = 1;
      itemForm.style.display = 'none';
    }
  }

  _insertBefore(el, referenceNode) {
    referenceNode.parentNode.insertBefore(el, referenceNode);
  }

  _insertAfter(el, referenceNode) {
    referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
  }
}
